module.exports = __webpack_public_path__ + "static/media/4510.43a1218a.jpg";